import Vue from 'vue'

// axios
import axios from 'axios'
import { appVersion } from '../../package.json'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
    // 관리자에서 API 호출 시 package.json의 appVersion을 헤더에 포함하여 버전 라우팅 시 사용
    'app-version': appVersion,
  },
})

// 모의해킹 점검 보고서 대응: Rate Limit(429) 응답 시 사용자 안내
// UX 개선 필요 시 toast/modal 패턴으로 전환 가능
axiosIns.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 429) {
      // eslint-disable-next-line no-alert
      alert('요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요.')
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
